import { ISubmitAction } from 'core/types';

// The action Enter in a field runs: the one marked as default, otherwise the first. None while its
// button is disabled, by the action itself or because the form is busy saving.
export const getDefaultSubmitAction = (
  submitActions: ISubmitAction[],
  isSubmitDisabled = false
): ISubmitAction | undefined => {
  const defaultSubmitAction = submitActions.find((action) => action.isDefault) ?? submitActions[0];

  if (isSubmitDisabled || defaultSubmitAction?.disabled) {
    return undefined;
  }

  return defaultSubmitAction;
};
